/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated.js';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { roundDependencies } from './dependenciesRound.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { zerosDependencies } from './dependenciesZeros.generated.js';
import { createFloor } from '../../factoriesAny.js';
export var floorDependencies = {
  DenseMatrixDependencies,
  equalScalarDependencies,
  matrixDependencies,
  roundDependencies,
  typedDependencies,
  zerosDependencies,
  createFloor
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesFloor.generated.js
// module id = iw6Z
// module chunks = 3